import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-meaning-of-acronyms-personality',
  templateUrl: './meaning-of-acronyms-personality.component.html',
  styleUrls: ['./meaning-of-acronyms-personality.component.scss']
})
export class MeaningOfAcronymsPersonalityComponent implements OnInit {
  recommendedPersonalities: any;
  loading: Boolean = true;

  @Input() meaning;
  @Input() description;
  constructor(

  ) { }

  ngOnInit() {
  }
}
